<!-- 盘库详情页 -->
<template>
    <div class="app-container">
      <Table
        ref="tableRef"
        :showSearchIcon="true"
        :showText="true"
        :isCreateSearch="false"
        :isSelect="true"
        :data="tableData"
        :columns="columns"
        :total="total"
        :loading="loading"
        :searchAttrName="searchAttrName"
        rowKey="checkInventoryProductRecordId"
        exportDataUrl="/checkInventory/selectCheckInventoryProductRecord"
        tableName="checkInventoryDetail"
        :customParamsFun="getCustomParamsFun"
        @onSearch="handleSearch"
      >
      <template #textInfo>
            <el-row class="textInfo" :gutter="8">
                <el-col :span="5">
                    <div><span class="textName">{{checkInventoryRecord.warehouseName}}</span></div>
                </el-col>
                <el-col :span="5">
                    <div><span class="textName">主材：</span>{{checkInventoryRecord.mainMaterialTotal || 0}}</div>
                </el-col>
                <el-col :span="5">
                    <div><span class="textName">辅材：</span>{{checkInventoryRecord.auxiliaryMaterialTotal || 0}}</div>
                </el-col>
                <el-col :span="4">
                    <div><span class="textName">耗材：</span>{{checkInventoryRecord.consumptionMaterialTotal || 0}}</div>
                </el-col>
                <el-col :span="5">
                    <div><span class="textName">总数：</span>{{checkInventoryRecord.inventoryTotal || 0}}</div>
                </el-col>
            </el-row>
        </template>
      </Table>
      <!-- 详情 -->
      <el-dialog title="详情" v-model="dialogOpen" width="1200px" append-to-body>
        <Table
            ref="tableRefDialog"
            :showSearchIcon="true"
            :isCreateSearch="false"
            :data="tableDataDialog"
            :columns="columnsDialog"
            :total="totalDialog"
            :loading="loadingDialog"
            rowKey="productInventoryId"
            tableName="checkInventoryDelProDetail"
            exportDataUrl="/checkInventory/selectCheckInventoryProductRecord"
            :customParamsFun="getCustomParamsFunPro"
            @onSearch="handleSearchDialog"
        >
        </Table>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="closed">关闭</el-button>
            <!-- <el-button type="primary" @click="onConfirm">{{ $t('msg.universal.confirm') }}</el-button> -->
          </span>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script setup>
  
  import Table from "@/components/Element/Table";
  import { ref,watch,onMounted,getCurrentInstance} from "vue";
  import { getCustomTableCols } from "@/tableColumn";
  import {
    selectCheckInventoryProductRecord,
    selectCheckInventoryCheckRecord
  } from "@/api/checkInventory";
  import useCacheStore from "@/store/modules/cache";
  import { isNull } from "@/utils/fangerUtils";
  import { succesMsg } from "@/utils/msgBox";
  import { useRoute } from 'vue-router'
  const cacheStore = useCacheStore();
  const { proxy } = getCurrentInstance()
  const { getWarehouseNameById} = cacheStore;
  
  /**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
//   defineOptions({
//     name: "checkInventoryDetail",
//   });
  const props = defineProps({
    checkInventoryRecord: { // 自定义参数函数
        required: false,
        type: Object
    },
  });
  const tableRef = ref(null);
  const tableData = ref([]);
  const total = ref(0);
  const loading = ref(false);
  const tableDataDialog = ref([]);
  const totalDialog = ref(0);
  const loadingDialog = ref(false);
  const dialogOpen = ref(false);
  
  const searchAttrName = ['productName','productType','usageType'];
  onMounted(()=>{
      watch(() => props.checkInventoryRecord.checkInventoryRecordId,
            (newVal, oldVal) => {
                tableRef.value.onSearch()
                // proSearch()
            }, {
            immediate: true
            }
        )
  })
  const getCustomParamsFun = () => {
    return {
        checkInventoryRecordId: props.checkInventoryRecord.checkInventoryRecordId
    }
  }
  // 搜索
  const handleSearch = (data) => {
    loading.value = true;
    selectCheckInventoryProductRecord(data).then(res =>{
        tableData.value = res.data;
        total.value = res.pageParam.totleInfo
    }).finally(()=>{
        loading.value = false;
    })
      
  };
  const tableRefDialog = ref(null)
  const checkInventoryProductRecordId = ref('')
  watch(() => checkInventoryProductRecordId.value,
            (newVal, oldVal) => {
                if(newVal){
                    proxy.$nextTick(() => {
                        tableRefDialog.value.onSearch()
                    })
                }
                // proSearch()
            }
        )
 const getCustomParamsFunPro = () => {
    return {
        checkInventoryProductRecordId: checkInventoryProductRecordId.value
    }
  }
  const handleSearchDialog = (data) => {
    loading.value = true;
    selectCheckInventoryCheckRecord(data).then(res =>{
        tableDataDialog.value = res.data;
        totalDialog.value = res.pageParam.totleInfo
    }).finally(()=>{
        loading.value = false;
    })
      
  };
  const handleDetail = (event,row)=>{
      dialogOpen.value = true
    checkInventoryProductRecordId.value = row.checkInventoryProductRecordId
    // handleSearchDialog()
  }
  const closed = ()=>{
    dialogOpen.value = false
    checkInventoryProductRecordId.value = ''
  }
  const handleControlDisabled = (row) => {
    return row.usageType !== "1";
    };
  const columns = getCustomTableCols([
    "productName",
    "productType",
    "usageType",
    // "inventoryStatus",
    "inventoryTotal",
    "operateTime",
    "operatorName",
    {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "详情",
        controlType: "success",
        controlText: true,
        controlFun: handleDetail,
        controlDisabled: handleControlDisabled,
      },
    ],
    },
  ]);
  const columnsDialog = getCustomTableCols([
    "eqptCode",
    "inventoryOperationType",
    "inventoryStatus",
    "inWarehouseTime",
    "outWarehouseTime",
    "status",
    "checkTime",
    "remarks",
    "operateTime",
    "operatorName"
  ]);
  </script>
  
  <style lang="scss" scoped>
    .textInfo{
        font-size:18px;
        width:80%;
        color:#ed064b;
        font-weight:bold;
        .textName{
            font-size:20px;
            color:#555;
        }
    }
  </style>
  